import React, { useEffect, useState } from "react";
import Select from "react-select";
import infoCircle from "../../assets/icons/infocircle.svg";
import searchIcon from "../../assets/icons/search.svg";
import like from "../../assets/icons/like.svg";
import share from "../../assets/icons/share.svg";
import reload from "../../assets/icons/reload.svg";
import CustomTabsV2 from "../universal/CustomTabsV2";
import { AddNotificationsListHooks } from "../../screens/NotificationList/hooks/NotificationsListHooks";
import CustomLineChart from "../charts/lineChart/CustomLineChart";
import SingleTab from "../universal/SingleTab";
import CustomCarousel from "../universal/CustomCarousel";
// import DateTimePicker from "react-datetime-picker";
import DropdownField from "../InputFields/DropDown";
import { readLanguageAction } from "../../store/Languages/LanguageAction";
import { useDispatch } from "react-redux";

import "react-tooltip/dist/react-tooltip.css";
import { Tooltip } from "react-tooltip";
import { FaInfoCircle } from "react-icons/fa";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { MdOutlineCalendarToday } from "react-icons/md";
import MyStatefulEditor from "../universal/MyStatefulEditor";
import UploadControlsV2 from "../TWG/UploadControlsV2";

const AddNotificationsFields = ({ id }) => {
  const {
    languages,
    activeTab,
    setActiveTab,
    inputs,
    handleInputChange,
    handleFileInputChange,
    notificationInputs,
    handleFileUpload,
    handleTime,
    handleChange,
    handleCategoryDescriptionChange,
    handleSave,
    selected,
    setSelected,
    updateStateWithTranslation,
  } = AddNotificationsListHooks(id);

  const dispatch = useDispatch();


  const [languageOptions, setLanguageOptions] = useState([]);
  const [userTab, setUserTab] = useState("Month");

  const [notificationTypeOptions, setNotificationTypeOptions] = useState([
    {
      roleName: "Text",
      value: "0",
      shortCode: "0",
    },
    {
      roleName: "Rich Text",
      value: "1",
      shortCode: "1",
    },
    {
      roleName: "Video",
      value: "2",
      shortCode: "2",
    },
    {
      roleName: "Image",
      value: "3",
      shortCode: "3",
    },
  ]);

  const [notificationType, setNotificationType] = useState("text");

  useEffect(() => {
    dispatch(
      readLanguageAction({
        callback: getAllLanguageResponse,
      })
    );
  }, []);

  const getAllLanguageResponse = (response) => {
    if (response?.type === 1) {
      setLanguageOptions([]);
      const data = response?.data;
      data.map((language) => {
        if (language?.status === 1) {
          setLanguageOptions((prev) => [
            ...prev,
            {
              roleName: language?.language_name,
              value: language?.language_code,
              shortCode: language?.language_code,
            },
          ]);
        }
      });
    }
  };

  return (
    <div className="grid md:grid-cols-12 grid-cols-1 grid-rows-1 h-full w-full flex-1 rounded-2xl overflow-hidden">
      <div className="flex flex-col h-full col-span-12 row-span-1 bg-greyishV2 bg-opacity-50 md:border-l md:border-r border-greyish border-opacity-30">
        <div className="flex justify-between gap-4 items-center h-[90px] px-4 border-b border-[#28292a] ">
          <p className="text-white font-semibold text-lg">Send Notifications</p>
          <div className="flex items-center gap-5">
            {" "}
            <div className="flex gap-5 items-center">
              {selected !== "en" && (
                <button
                  onClick={updateStateWithTranslation}
                  className="flex items-center gap-1 text-greyish text-[11px] font-medium whitespace-nowrap"
                >
                  <img src={reload} alt="" /> Auto fill data with google translation
                </button>
              )}
              <div className="w-[100px]">
                <DropdownField
                  value={selected}
                  options={languageOptions}
                  labelText={""}
                  width={"w-full"}
                  handleInputChange={(e) => setSelected(e.target.value)}
                />
              </div>
            </div>
            {id === undefined && (
              <div className="w-full flex items-end justify-end gap-4">
                <button
                  className="text-yellowish bg-blackish font-medium text-[12px] border border-yellowish rounded-xl py-2 px-6"
                  onClick={handleSave}
                >
                  Send Notification
                </button>
              </div>
            )}
          </div>
        </div>
        {/* TAB CONTENT  */}
        <div className="px-4 my-4">
          <div className="h-[68vh] overflow-y-auto overflow-x-hidden">
            <div className="flex flex-col px-5 gap-x-4 gap-y-4 mx-1 w-full pb-10">
              <DropdownField
                tooltipId="add_notification"
                tooltipText="Select the Notification Type"
                value={notificationInputs?.notificaiton_type}
                options={notificationTypeOptions}
                labelText={"Select Notification Type"}
                width={"p-1"}
                name="notificaiton_type"
                handleInputChange={handleChange}
              />
              <div>
                <label
                  htmlFor="notification_title"
                  className="text-[12px] text-greyish font-medium leading-4 flex items-center gap-2"
                >
                  Notification Title
                  <FaInfoCircle
                    data-tooltip-id="add_notification"
                    data-tooltip-content="Enter the Notification Title"
                  />
                </label>
                <input
                  name="notification_title"
                  type="text"
                  className={`bg-blackish p-2 w-full text-white text-[14px] font-medium mt-2 leading-4 rounded-md h-10 `}
                  value={notificationInputs.notification_title}
                  placeholder="Enter Notification Name"
                  onChange={handleChange}
                />
              </div>
              {notificationInputs?.notificaiton_type !== "1" && (
                <div className="md:col-span-2 col-span-1">
                  <label
                    htmlFor="notification_description"
                    className="text-[12px] text-greyish font-medium leading-4 flex items-center gap-2"
                  >
                    Notification Description
                    <FaInfoCircle
                      data-tooltip-id="add_notification"
                      data-tooltip-content="Enter the Notification Description"
                    />
                  </label>
                  <textarea
                    rows={6}
                    className={`bg-blackish p-2 w-full text-white text-[14px] font-medium mt-2 leading-4 rounded-md`}
                    name="notification_description"
                    placeholder="Enter Notification Description"
                    value={notificationInputs.notification_description}
                    onChange={handleChange}
                  />
                </div>
              )}
              {notificationInputs?.notificaiton_type === "1" && (
                <div className="md:col-span-2 col-span-1">
                  <label
                    htmlFor="notification_richtext"
                    className="text-[12px] text-greyish font-medium leading-4 flex items-center gap-2"
                  >
                    Notification Description
                    <FaInfoCircle
                      data-tooltip-id="add_notification"
                      data-tooltip-content="Enter the Notification Description"
                    />
                  </label>
                  <MyStatefulEditor
                    darkMode={true}
                    labelColor={"white"}
                    labelText={""}
                    placeholder={"Enter Notification Description"}
                    htmlFor="notification_richtext"
                    name="notification_richtext"
                    value={notificationInputs.notification_richtext}
                    handleInputChange={handleChange}
                  />
                </div>
              )}
              {/* <div className="w-full flex flex-col">
                <label
                  htmlFor="notification_schedule_time"
                  className="text-[12px] text-greyish font-medium leading-4 flex items-center gap-2"
                >
                  Schedule Time
                  <FaInfoCircle
                    data-tooltip-id="add_notification"
                    data-tooltip-content="Enter the Schedule Time"
                  />
                </label>
                <DatePicker
                  selected={notificationInputs?.notification_schedule_time}
                  onChange={(value) => handleTime(value)}
                  isClearable={true}
                  clearButtonClassName="flex"
                  showIcon={true}
                  showMonthDropdown={true}
                  showYearDropdown={true}
                  dropdownMode="select"
                  toggleCalendarOnIconClick={true}
                  placeholderText="MM/DD/YYYY"
                  icon={<MdOutlineCalendarToday className="mr-2 cursor-pointer text-white" />}
                  wrapperClassName="mt-2 custom-datepicker"
                  className="bg-blackish stroke-white !p-3 !pl-8 w-full text-white text-[14px] font-medium leading-4 rounded-md"
                />
              </div> */}
              {/* {["2", "3"].includes(notificationInputs?.notificaiton_type) && (
                <div className="flex flex-row gap-3 items-center col-span-2">
                  <div className="w-1/2">
                    <label
                      htmlFor="notification_asset_url"
                      className="text-[12px] text-greyish font-medium leading-4 "
                    >
                      {`Upload ${
                        notificationTypeOptions?.[notificationInputs?.notificaiton_type]?.roleName
                      }`}
                    </label>
                    <input
                      name="notification_asset_url"
                      className={`bg-blackish p-2 w-full text-white text-[14px] font-medium mt-2 leading-4 rounded-md h-10 `}
                      type="file"
                      accept="image/*"
                      onChange={(e) => handleFileUpload(e, notificationInputs?.notificaiton_type)}
                    />
                  </div>

                  <div className="w-1/2 md:col-span-2 col-span-1">
                    <label
                      htmlFor="notification_asset_url"
                      className="text-[12px] text-greyish font-medium leading-4 "
                    >
                      Upload URL
                    </label>
                    <input
                      name="notification_asset_url"
                      placeholder="Enter URL"
                      type="text"
                      className={`bg-blackish p-2 w-full text-white text-[14px] font-medium mt-2 leading-4 rounded-md h-10 `}
                      value={notificationInputs.notification_asset_url}
                      onChange={handleChange}
                    />
                  </div>
                </div>
              )} */}

              {["2", "3"].includes(notificationInputs?.notificaiton_type) && (
                <UploadControlsV2
                  tooltipTitle={`Upload ${
                    notificationTypeOptions?.[notificationInputs?.notificaiton_type]?.roleName
                  }`}
                  className="my-2 col-span-2"
                  title={`Upload ${
                    notificationTypeOptions?.[notificationInputs?.notificaiton_type]?.roleName
                  }`}
                  helpText={
                    <span className="font-medium mt-2">
                      (Please Upload{" "}
                      {notificationTypeOptions?.[notificationInputs?.notificaiton_type]?.roleName}{" "}
                      of the ratio <i className="font-semibold">2:3</i> only for proper alignment with the layout design)
                    </span>
                  }
                  subtitle={`Upload ${
                    notificationTypeOptions?.[notificationInputs?.notificaiton_type]?.roleName
                  }`}
                  handleMobileChangeUrl={handleChange}
                  mobileUploadProgressId="mobileUploadNotificationAssetUrl"
                  handleMobileFileUpload={(e) =>
                    handleFileUpload(
                      e,
                      notificationInputs?.notificaiton_type,
                      "mobileUploadNotificationAssetUrl"
                    )
                  }
                  mobileUploadName="notification_asset_url"
                  mobileUploadUrl={notificationInputs?.notification_asset_url}
                  mobileUploadCropRequired={notificationInputs?.notificaiton_type === "3"}
                  mobileUploadCropAspect={2 / 3}
                  requiredMessage="Please upload the Image URL"
                  showTabletUpload={false}
                  showWebUpload={false}
                  accept={notificationInputs?.notificaiton_type === "2" ? "video" : "image"}
                />
              )}
            </div>
          </div>
          <Tooltip id="add_notification" className="border border-greyish border-opacity-20" />
        </div>
      </div>
      {/* <div className="col-span-4 row-span-1 bg-[#1b1b1b]">
        <CustomTabsV2
          tabHeight={"h-[64px]"}
          tabsTitleArray={["Stats"]}
          tabsContentObject={{
            Stats: (
              <div className="mt-8 flex items-center justify-center w-full text-white">
                No stats available for notification
              </div>
            ),
          }}
        />
      </div> */}
    </div>
  );
};

export default AddNotificationsFields;
